import { renderCanvasDiagram } from './renderCanvasDiagram.js';

export function initDiagrams(root = document) {
  const diagrams = root.querySelectorAll('[data-documentation-canvas-diagram]');

  diagrams.forEach(figure => {
    if (figure.dataset.diagramInitialized === 'true') return;

    const canvas = figure.querySelector('canvas[data-diagram-canvas]');
    if (!canvas) return;

    const slug = canvas.dataset.diagramSlug || figure.dataset.diagramSlug;
    const payload = readDiagramPayload(root, slug);
    if (!payload) return;

    const renderer = renderCanvasDiagram({
      canvas,
      wrapper: figure.querySelector('[data-diagram-canvas-wrapper]') || canvas.parentElement,
      statusChip: figure.querySelector('[data-diagram-status]'),
      overlay: figure.querySelector('[data-diagram-overlay]'),
      overlayTitle: figure.querySelector('[data-diagram-overlay-title]'),
      overlayDesc: figure.querySelector('[data-diagram-overlay-desc]'),
      overlayTag: figure.querySelector('[data-diagram-overlay-tag]'),
      data: payload
    });

    if (!renderer) return;

    figure.dataset.diagramInitialized = 'true';
    canvas.dataset.diagramInitialized = 'true';
  });
}

export function readDiagramPayload(root, slug) {
  const payloadNode = Array.from(root.querySelectorAll('script[type="application/json"][data-diagram-payload-for]'))
    .find(node => node.dataset.diagramPayloadFor === slug);

  if (!payloadNode) return null;

  try {
    return JSON.parse(payloadNode.textContent || '{}');
  } catch (error) {
    console.error('Diagram data parse error for slug:', slug, error);
    return null;
  }
}
